import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { scheduleQueryKeys } from "toptaal-shared"
import { fetchStudentSchedule } from "@/api/services/schedule"
import { CalendarWithModal } from "@/components/modals/calendar/CalendarWithModal"

export const Route = createFileRoute("/beheer/cursisten/$studentId/lessen/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const { studentId } = useParams({ from: "/beheer/cursisten/$studentId" })

  return (
    <CalendarWithModal
      id={Number(studentId)}
      showStudentAttendance
      getQueryKey={scheduleQueryKeys.student}
      queryFn={({ id, startDate, endDate }) =>
        fetchStudentSchedule({ id, startDate, endDate })
      }
    />
  )
}
